import React, { useState, useEffect, useRef } from "react";
import { FaPlay, FaEye } from "react-icons/fa"; // Make sure you have react-icons installed
import { FaCheck } from "react-icons/fa6";
import { updatelaststedata } from "../../../Api/contact";
import { getCurrentUser } from "../../../Api/auth.js";
import Modal from "react-bootstrap/Modal";
import { MdClose } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { Spinner } from "react-bootstrap";


const NoteData = ({ userdata, remoteData, projectid, user }) => {
    const [textAreaData, setTextAreaData] = useState("");
    const playerRefs = useRef([]);
    const [apiloader, setApiLoader] = useState(false);
    const updateremotefittingdata = () => {
        setApiLoader(true);
        const data = {
            notes: textAreaData,
            project_id: projectid,
            fitter_id: userdata?._id,
            fitter_role: userdata?.role_id,
            firstname: user?.firstname,
            lastname: user?.lastname,
            email: user?.email,
        }

        updatelaststedata(data).then((res) => {
            if (!res.data.status) {
                alert(res.data.data[0].detail);
            } else {
                if (userdata.role_id === 4) {
                    window.location.href = "/user-dashboard";
                } else if (userdata.role_id === 1 || userdata.role_id === 10) {
                    window.location.href = "/fitter-dashboard";
                } else {
                    window.location.href = "/dashboard";
                }
            }

        }).catch((error) => {
            console.log("error", error);
        }).finally(() => {
            setApiLoader(true);
        })
    }

    const [role_id, seRole_id] = useState(null);
    const [ironDataModal, setIronDataModal] = useState(false);

    const handleCloseModal = () => {
        setIronDataModal(false);
    };

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            seRole_id(getCurrentUserdata.user.role_id);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);
    return (
        <div
            className="row black_bg_box cf mx-3"
            style={{ borderRadius: "40px", backgroundColor: "#1e2025" }}
        >
            <div className="club-fitting-card new-m">
                <div className="gab_title">
                    <div className="collapsed d-flex align-items-center">
                        <div className="gab_text d-flex align-items-center" style={{ height: '76px' }}><h5 className='cf-title '>Submit Fitting</h5></div>
                    </div>
                </div>
                {
                    role_id == 4 && (<div className='gab_text' style={{ fontSize: '20px' }}>
                        Before you submit your fitting leave us some notes below if needed. Once you submit this our team will be in contact.
                    </div>)
                }
                {/* <div className='gab_text' style={{ fontSize: '20px' }}>
                    Before you submit your fitting leave us some notes below if needed. Once you submit this our team will be in contact.
                </div> */}
            </div>
            {
                role_id == 4 && (<div className="col-12 my-4 w-full">
                    <div eventKey="2" className="mobile-accordion" onClick={() => setIronDataModal(true)}>
                        <div className="bg_green_light" style={{ backgroundColor: "#36454F" }}>
                            <div className="gs_fr_tops" id="lesson_card_1">
                                <div>
                                    <div className="gab_title">
                                        <div className="gab_text bg-accordion-title">
                                            <h5>What happens next</h5>
                                        </div>
                                        <div className="">
                                            <div className="barplay_icon_item">
                                                <FaEye size={15} color="#ffffff" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)
            }
            {/* <div className="col-12 mt-4 w-full">
                <div eventKey="2" className="mobile-accordion">
                    <div className="bg_green_light" style={{ backgroundColor: "#36454F" }}>
                        <div className="gs_fr_tops" id="lesson_card_1">
                            <div>
                                <div className="gab_title">
                                    <div className="gab_text bg-accordion-title">
                                        <h5>What happens next</h5>
                                    </div>
                                    <div className="">
                                        <div className="barplay_icon_item">
                                            <FaPlay size={15} color="#ffffff" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}


            <Modal
                show={ironDataModal}
                centered
                className="step card-radius popup-modal-dark"
            >
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile" style={{ padding: '4px 15px' }}>
                    <div className='row d-flex justify-content-between align-items-center' >
                        <img className='col-9 text-white remote-text mt-4' src={require("../../../assets/images/remote-fitting-logo.png")} alt="logo" />
                        <div className="col-3 closing-icon d-flex align-items-center justify-content-end">
                            {/* <IoClose
                                                color="#ffffff"
                                                onClick={handleCloseModal}
                                            /> */}
                            <button type="button" className="btn-close" style={{ backgroundColor: 'transparent', border: 'none' }} onClick={handleCloseModal} aria-label="Close">
                                <IoClose style={{ strokeWidth: '30px' }} />
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-12 mb-0'>
                            <div className="ifream-video-box ratio iframe_wrapper" style={{ paddingBottom: '177.78%' }}>
                                <div id="player" className="v-video">
                                    <iframe
                                        ref={(el) => (playerRefs.current[0] = el)}
                                        src="https://player.vimeo.com/video/1048743298?badge=0&autopause=0&player_id=0&app_id=58479&controls=1"
                                        frameBorder="0"
                                        allow="autoplay; fullscreen; picture-in-picture"
                                        allowFullScreen
                                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                        title="Your Video Title"
                                        data-ready="true"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>




            <div className="custom-input-container my-2 col-12">
                <textarea
                    onChange={(e) => {
                        setTextAreaData(e.target.value);
                    }}
                    placeholder="Leave us a Note..."
                    className="custom-textarea col-12"
                    rows={5}
                />
            </div>
            <div className="save-attach d-flex align-items-center justify-content-between mt-3 mb-4 col-12">
                <button
                    className="btn save-attach-btn col-12 py-4"
                    style={{ backgroundColor: "#99EA24" }}
                    disabled={
                        !(
                            remoteData?.swingdata?.status &&
                            remoteData?.irondata?.status &&
                            remoteData?.balldata?.status
                        )
                    }
                    onClick={updateremotefittingdata}
                >
                    {apiloader ? (
                        <Spinner animation="border" className="border-black" />
                    ) : (
                        "Submit Fitting"
                    )}
                </button>
            </div>
        </div>
    );
};

export default NoteData;
